import { Theme } from '@mui/material/styles';

export const explanationAlertStyles = (theme: Theme, isDark: boolean) => ({
  icon: {
    backgroundColor: 'rgb(212 245 76 / 85%)',
    '& .MuiAlert-icon': {
      '& svg': { color: isDark ? '#111432' : theme.palette.text.primary }
    }
  },
  title: {
    fontVariationSettings: "'wght' 600",
    color: isDark ? '#111432' : theme.palette.text.primary
  },
  mainText: {
    display: 'inline',
    color: isDark
      ? theme.palette.primary.contrastText
      : theme.palette.text.primary
  },
  textContainer: { display: 'inline' },
  boldText: {
    fontVariationSettings: "'wght' 600"
  }
});
